var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgViewIcon = function SvgViewIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2667 0.5C5.6 0.5 1.61467 3.40267 0 7.5C1.61467 11.5973 5.6 14.5 10.2667 14.5C14.9333 14.5 18.9187 11.5973 20.5333 7.5C18.9187 3.40267 14.9333 0.5 10.2667 0.5ZM10.2667 12.1667C7.69067 12.1667 5.6 10.076 5.6 7.5C5.6 4.924 7.69067 2.83333 10.2667 2.83333C12.8427 2.83333 14.9333 4.924 14.9333 7.5C14.9333 10.076 12.8427 12.1667 10.2667 12.1667ZM10.2667 4.7C8.71733 4.7 7.46667 5.95067 7.46667 7.5C7.46667 9.04933 8.71733 10.3 10.2667 10.3C11.816 10.3 13.0667 9.04933 13.0667 7.5C13.0667 5.95067 11.816 4.7 10.2667 4.7Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgViewIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/viewIcon.47d86e0f.svg";
export { ForwardRef as ReactComponent };